export class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const track = this.querySelector('.announcement-bar__marquee-track');
    const group = this.querySelector('.announcement-bar__marquee-group');
    if (!track || !group) return;

    const slides = [...group.children];
    slides.forEach((slide) => {
      slide.removeAttribute('aria-hidden');
      slide.classList.remove('is-entering', 'is-leaving');
    });

    const enabled = this.dataset.marqueeEnabled === 'true';
    if (enabled && slides.length > 0) {
      const duplicate = group.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.removeAttribute('data-shopify-editor-block');
      duplicate.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
      duplicate.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => node.setAttribute('tabindex', '-1'));
      track.append(duplicate);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.dataset.ready = 'true';
        });
      });
    }
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
